<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>新增管理</el-breadcrumb-item>
      <el-breadcrumb-item>采购管理</el-breadcrumb-item>
      <el-breadcrumb-item>采购订单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
<!--          <el-form-item label="">
            <el-date-picker v-model="keywords.begintime" type="date" placeholder="选择开始日期" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="keywords.endtime" type="date" placeholder="选择结束日期" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item> -->
          <el-form-item label="">
            <el-input v-model="keywords.purchasecompany" @keyup.enter.native="clickSearch" placeholder="请输入采购单位"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.projectname" @keyup.enter.native="clickSearch" placeholder="请输入项目名称"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.bomname" @keyup.enter.native="clickSearch" placeholder="请输入物料名称"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.bomsn" @keyup.enter.native="clickSearch" placeholder="请输入物料编码"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.reviewstatus" placeholder="请选择" style="width: 100%">
              <el-option label="请选择审批状态" value="-1"></el-option>
              <el-option label="审核被拒绝" value="0"></el-option>
              <el-option label="待采购审核" value="1"></el-option>
              <el-option label="待财务审核" value="2"></el-option>
              <el-option label="待副总审核" value="3"></el-option>
              <el-option label="待总经理审核" value="4"></el-option>
              <el-option label="已审核" value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clickSearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border :cell-style="{padding: '0'}" height="440">
          <el-table-column prop="Orderid" label="合同编号" width="200"></el-table-column>
          <el-table-column prop="Suppliername" label="供应商名称" width="300"></el-table-column>
          <el-table-column prop="Projectname" label="项目名称" width="300"></el-table-column>
          <el-table-column prop="Projectclassification" label="项目分类" width="100"></el-table-column>
          <el-table-column prop="Bomname" label="物料名称" width="300"></el-table-column>
          <el-table-column prop="Bomsn" label="物料编号" width="300"></el-table-column>
<!--          <el-table-column prop="Contactname" label="供应商联系人" width="150"></el-table-column>
          <el-table-column prop="Contactphone" label="供应商联系方式" width="200"></el-table-column> -->
          <el-table-column prop="Contractunitprice" label="合同单价" width="100"></el-table-column>
          <el-table-column prop="Contractnum" label="合同数量" width="100"></el-table-column>
          <el-table-column prop="Contractamount" label="合同金额" width="100"></el-table-column>
          <el-table-column prop="Sublist" label="付款信息" width="150">
            <template slot-scope="props">
              <span class="blue" style="margin-left: 0; margin-right: 5px;color: #48c9b0;" @click="cilckSublist(props.row)">点击查看详情</span>
            </template>
          </el-table-column>
          <el-table-column prop="Receivetime" label="交货日期" width="200"></el-table-column>
          <el-table-column prop="Purchasecompany" label="采购单位" width="300"></el-table-column>
          <el-table-column prop="ReviewstatusName" label="审核状态" width="150"></el-table-column>
          <el-table-column prop="Opinion" label="审核意见" width="150"></el-table-column>
          <el-table-column prop="Reply" label="答复审核意见" width="150"></el-table-column>
          <el-table-column prop="Beizhu" label="备注" width="200"></el-table-column>
          <el-table-column label="附件" width="200">
            <template v-slot="scope">
              <el-button v-for="Attachment in scope.row.Attachments" type="text" @click="clickfile(Attachment)">附件</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="operation" label="操作" width="200" fixed="right">
            <template v-slot="scope">
              <el-button v-if="scope.row.Reviewstatus == 0 && useriderp == scope.row.Createuserid" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickedit(scope.row)">修改</el-button>
              <el-button v-if="scope.row.Reviewstatus == 0 && useriderp == scope.row.Createuserid" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickDel(scope.row)">删除</el-button>
              <el-button v-if="scope.row.Reviewstatus == 0 && useriderp == scope.row.Createuserid" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe0(scope.row)">再次提交审核</el-button>
              <el-button v-if="scope.row.Reviewstatus == 1 && SubRule_Erp6PurchaseOrder_CaiGou" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe1234(scope.row,1)">采购审核</el-button>
              <el-button v-if="scope.row.Reviewstatus == 2 && SubRule_Erp6PurchaseOrder_CaiWu" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe1234(scope.row,2)">财务审核</el-button>
              <el-button v-if="scope.row.Reviewstatus == 3 && SubRule_Erp6PurchaseOrder_FuZong" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe1234(scope.row,3)">副总审核</el-button>
              <el-button v-if="scope.row.Reviewstatus == 4 && SubRule_Erp6PurchaseOrder_Zong" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe1234(scope.row,4)">总经理审核</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <!-- 审批 start -->
        <el-dialog
          title=""
          :visible.sync="dialogShenPi"
          width="880px">
          <el-form :model="modelShenPi" ref="modelShenPi" label-width="170px">
            <el-form-item label="审批意见(可选)" class="addAdminForm">
              <el-input v-model="modelShenPi.opinion" placeholder="如果拒绝,请填写审批意见"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="ShenHeOK">同意</el-button>
              <el-button type="danger" @click="ShenHeNO">拒绝</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        <!-- 审批 end -->

        <el-dialog
          title="再次提交审核"
          :visible.sync="dialogSubmitAgain"
          width="35%">
          <el-form :model="modelSubmitAgain" ref="modelSubmitAgain" label-width="170px">
            <el-form-item label="答复审批意见" class="addAdminForm">
              <el-input v-model="modelSubmitAgain.reply" placeholder="请填写答复"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="SubmitAgain">提交</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 添加 start -->
    <el-tab-pane label="添加采购订单" name="three">
      <el-form :model="addForm" ref="addForm" label-width="170px">
        <el-form-item class="addAdminForm" label="采购单位">
          <el-select v-model="addForm.purchasecompany" placeholder="请选择">
            <el-option
              v-for="item in PurchaseCompanyOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminForm" label="项目名称">
          <el-select v-model="addForm.projectcode" placeholder="请选择" class="select" @change="selectProject()" filterable>
            <el-option
              v-for="item in ProjectNameList" :key="item.Code" :label="item.Name" :value="item.Code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminForm" label="物料名称" v-if="addForm.projectclassification == '产品'">
          <el-select v-model="addForm.bomsn" placeholder="请选择" class="select" @change="selectBom()" filterable>
            <el-option
              v-for="item in BomDanCaiList" :key="item.Materialcode" :label="item.Info" :value="item.Materialcode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminForm" label="供应商">
          <el-select v-model="addForm.supplierid" placeholder="请选择" class="select" filterable>
            <el-option
              v-for="item in SupplierProfileList" :key="item.Id" :label="item.Suppliername" :value="item.Id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminForm" label="合同单价">
          <el-input v-model="addForm.contractunitprice" @input="processAmount()"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm" label="合同数量">
          <el-input v-model="addForm.contractnum" @input="processAmount()"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm" label="合同金额">
          <el-input v-model="addForm.contractamount"></el-input>
        </el-form-item>
        <el-form-item class="addAdminFormLLL" label="付款信息">
          <div class="productdata1">
            <div class="productdata2">
              付款条件:
              <el-input v-model="addFormsub.paymentterms" style="width: 20%"></el-input>
              付款时间:
              <el-date-picker v-model="addFormsub.paymenttime" type="date" value-format="yyyy-MM-dd" style="width: 20%"></el-date-picker>
              付款金额:
              <el-input v-model="addFormsub.paymentamount" style="width: 15%"></el-input>
              <el-button type="text" @click="clickAddSubPayment()">增加</el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item class="addAdminFormLLL">
          <el-card v-for="item,index in addForm.SubPayment" :key="index">
            <li>付款条件：{{item.paymentterms}}；付款时间：{{item.paymenttime}}；付款金额：{{item.paymentamount}}；
            <el-button type="text" @click="clickDeleteSubPayment(index)">删除</el-button>
            </li>
          </el-card>
        </el-form-item>
        <el-form-item class="addAdminForm" label="交货日期">
          <el-date-picker v-model="addForm.receivetime" type="date" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="备注(可选)" class="addAdminForm">
          <el-input v-model="addForm.beizhu"></el-input>
        </el-form-item>
        <el-form-item label="附件(可选)" class="addAdminForm">
          <TencentyunCosUploadMultiImgOrPdf ref="MultiImgOrPdf" @change="addTencentyunCosUploadMultiImgOrPdf"></TencentyunCosUploadMultiImgOrPdf>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="apiAddErp6PurchaseOrder">添加</el-button>
          <el-button type="info" @click="clickReturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 添加 end -->

    <!-- start -->
    <el-tab-pane label="修改采购订单" name="five" disabled="disabled">
      <Erp6PurchaseOrderEdit ref="SubVuefive" v-on:triggerFunc="BackToFirst"></Erp6PurchaseOrderEdit>
    </el-tab-pane>
    <!-- end -->

    <el-dialog title="付款信息" :visible.sync="dialogPaymentInfo">
      <el-table :data="PaymentInfoList">
        <el-table-column property="Paymentterms" label="付款条件" min-width="30%"></el-table-column>
        <el-table-column property="Paymenttime" label="付款时间" min-width="30%"></el-table-column>
        <el-table-column property="Paymentamount" label="付款金额"  min-width="30%"></el-table-column>
      </el-table>
    </el-dialog>

  </el-tabs>
  </div>
</template>

<script>
import TencentyunCosUploadMultiImgOrPdf from '@/components/TencentyunCosUploadMultiImgOrPdf.vue'
import Erp6PurchaseOrderEdit from '@/componentsSubVue/Erp6PurchaseOrderEdit.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadMultiImgOrPdf,
    Erp6PurchaseOrderEdit
  },
  name: 'MyErp6PurchaseOrder',
  data () {
    return {
      useriderp: 0,
      activeName: 'first',
      PurchaseCompanyOptions:[],
      ProjectNameList:[],
      BomDanCaiList:[],
      SupplierProfileList:[],
      PaymentInfoList:[],
      addForm: {
        purchasecompany: '',
        projectcode: '',
        projectclassification: '',
        projectname: '',
        bomsn: '',
        supplierid: '',
        contractunitprice: '0',
        contractnum: '0',
        contractamount: '0',
        SubPayment: [],
        receivetime: '',
        beizhu: '',
        attachment: ''
      },
      addFormsub: {
        paymentterms: '',
        paymenttime: '',
        paymentamount: ''
      },
      modelShenPi: {
        id: 0,
        opinion: ''
      },
      modelSubmitAgain: {
        id: 0,
        reply: ''
      },
      // 查询
      keywords: {
        begintime: '',
        endtime: '',
        purchasecompany: '',
        projectname: '',
        bomname: '',
        bomsn: '',
        reviewstatus: '-1'
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      dialogShenPi: false,
      selectfytype: 0,
      dialogSubmitAgain: false,
      apiShenPiErp6PurchaseOrderUrl: '',
      SubRule_Erp6PurchaseOrder_CaiGou: false,
      SubRule_Erp6PurchaseOrder_CaiWu: false,
      SubRule_Erp6PurchaseOrder_FuZong: false,
      SubRule_Erp6PurchaseOrder_Zong: false,
      dialogPaymentInfo: false
    }
  },
  mounted () {
    this.useriderp = localStorage.getItem('Useriderp')
    this.PurchaseCompanyOptions = Vue.prototype.FunGetPurchaseCompany()
    this.apiGetErp6ProjectNameList()

    this.apiGetErp6PurchaseOrderNum()
    this.apiGetErp6PurchaseOrderList()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_Erp6PurchaseOrder_CaiGou', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Erp6PurchaseOrder_CaiGou = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Erp6PurchaseOrder_CaiWu', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Erp6PurchaseOrder_CaiWu = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Erp6PurchaseOrder_FuZong', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Erp6PurchaseOrder_FuZong = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Erp6PurchaseOrder_Zong', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Erp6PurchaseOrder_Zong = true
      }
    })
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.apiGetErp6PurchaseOrderNum()
      this.apiGetErp6PurchaseOrderList()
    },
    addTencentyunCosUploadMultiImgOrPdf (url) {
      this.addForm.attachment = url
    },
    processAmount (){
      var buf = Number(this.addForm.contractunitprice) * Number(this.addForm.contractnum)
      this.addForm.contractamount = this.pnum(buf)
    },
    pnum (num) {
      return Number(Number(num).toFixed(2))
    },
    clickfile (url) {
      Vue.prototype.FunReviewFileurl(url, this.$router)
    },
    clickedit (row) {
      var that = this
      that.activeName = 'five'
      that.$refs.SubVuefive.LoadData(row)
    },
    clickAddSubPayment () {
      if (this.addFormsub.paymentterms.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入付款条件')
        return
      }
      if (this.addFormsub.paymenttime.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入付款时间')
        return
      }
      if (!Vue.prototype.FunCheckNumber(this.addFormsub.paymentamount)) {
        Vue.prototype.FunAlertMsg('请输入付款金额')
        return
      }

      this.addForm.SubPayment.push({
        paymentterms: this.addFormsub.paymentterms,
        paymenttime: this.addFormsub.paymenttime,
        paymentamount: parseFloat(this.addFormsub.paymentamount)
      })
    },
    clickDeleteSubPayment (index) {
      var buflist = []
      for (var j = 0, len = this.addForm.SubPayment.length; j < len; j++) {
        if (index != j) {
          buflist.push(this.addForm.SubPayment[j])
        }
      }
      this.addForm.SubPayment = buflist
    },
    clickReturn () {
      this.activeName = 'first'
    },
    cilckSublist(row){
      this.dialogPaymentInfo = true
      this.PaymentInfoList = row.Sublist
    },
    ShenHe0 (row) {
      this.dialogSubmitAgain = true
      this.modelSubmitAgain.id = row.Id
      this.modelSubmitAgain.reply = ''
    },
    ShenHe1234 (row, number) {
      this.dialogShenPi = true
      this.modelShenPi.id = row.Id
      this.modelShenPi.opinion = ''
      if (number === 1) {
        this.apiShenPiErp6PurchaseOrderUrl = Vue.prototype.global.Url_ShenPiErp6PurchaseOrder1
      }
      if (number === 2) {
        this.apiShenPiErp6PurchaseOrderUrl = Vue.prototype.global.Url_ShenPiErp6PurchaseOrder2
      }
      if (number === 3) {
        this.apiShenPiErp6PurchaseOrderUrl = Vue.prototype.global.Url_ShenPiErp6PurchaseOrder3
      }
      if (number === 4) {
        this.apiShenPiErp6PurchaseOrderUrl = Vue.prototype.global.Url_ShenPiErp6PurchaseOrder4
      }
    },
    ShenHeOK () {
      this.dialogShenPi = false
      this.apiShenPiErp6PurchaseOrder(1)
    },
    ShenHeNO () {
      this.dialogShenPi = false
      this.apiShenPiErp6PurchaseOrder(-1)
    },
    SubmitAgain () {
      this.dialogSubmitAgain = false
      this.apiShenPiErp6PurchaseOrder0()
    },
    clickDel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelErp6PurchaseOrder(row.Id)
      })
    },
    clickSearch () {
      this.selectedPageNo = 1
      this.apiGetErp6PurchaseOrderNum()
      this.apiGetErp6PurchaseOrderList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetErp6PurchaseOrderList()
    },
    selectProject () {
      this.apiGetErp6BomDanCaiList()
      this.apiGetErp6SupplierProfileListByCode()
    },
    selectBom () {
      this.apiGetErp6SupplierProfileListByCode()
    },
    //为下拉框获取数据源-项目名称
    apiGetErp6ProjectNameList: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: '',
        code: '',
        classification: ''
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6ProjectNameList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.ProjectNameList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    //为下拉框获取数据源--物料信息
    apiGetErp6BomDanCaiList: function () {
      var that = this
      that.addForm.projectclassification = ''
      that.addForm.projectname = ''
      that.addForm.bomsn = ''
      that.BomDanCaiList = []

      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        productcode: that.addForm.projectcode
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6BomDanCaiList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.addForm.projectclassification = response.data.ProjectClassification
            that.addForm.projectname = response.data.ProjectName
            that.BomDanCaiList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    //为下拉框获取数据源--供应商信息
    apiGetErp6SupplierProfileListByCode: function () {
      var that = this
      that.addForm.supplierid = ''
      that.SupplierProfileList = []

      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        projectcode: that.addForm.projectcode,
        bomsn: that.addForm.bomsn
      }
      // 加上签名
      // console.log(data)
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6SupplierProfileListByCode, Qs.stringify(data))
        .then(function (response) {
          // console.log(response.data)
          if (response.data.Code === 200) {
            that.SupplierProfileList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apiGetErp6PurchaseOrderNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime,
        purchasecompany: that.keywords.purchasecompany,
        projectname: that.keywords.projectname,
        bomname: that.keywords.bomname,
        bomsn: that.keywords.bomsn,
        reviewstatus: that.keywords.reviewstatus
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6PurchaseOrderNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetErp6PurchaseOrderList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime,
        purchasecompany: that.keywords.purchasecompany,
        projectname: that.keywords.projectname,
        bomname: that.keywords.bomname,
        bomsn: that.keywords.bomsn,
        reviewstatus: that.keywords.reviewstatus
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6PurchaseOrderList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
            for (var i = 0; i < that.dataList.length; i++) {
              that.dataList[i].Attachments = []
              if (that.dataList[i].Attachment.length > 1) {
                that.dataList[i].Attachments = that.dataList[i].Attachment.split('@@@')
              }
            }
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddErp6PurchaseOrder: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        purchasecompany: that.addForm.purchasecompany,
        projectcode: that.addForm.projectcode,
        projectclassification: that.addForm.projectclassification,
        projectname: that.addForm.projectname,
        bomsn: that.addForm.bomsn,
        supplierid: that.addForm.supplierid,
        contractunitprice: that.addForm.contractunitprice,
        contractamount: that.addForm.contractamount,
        contractnum: that.addForm.contractnum,
        subpayment: JSON.stringify(that.addForm.SubPayment),
        receivetime: that.addForm.receivetime,
        beizhu: that.addForm.beizhu,
        attachment: that.addForm.attachment
      }
      console.log(data)
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddErp6PurchaseOrder, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetErp6PurchaseOrderNum()
            that.apiGetErp6PurchaseOrderList()

            // 清空添加
            that.addForm.purchasecompany = ''
            that.addForm.projectcode = ''
            that.addForm.projectclassification = ''
            that.addForm.projectname = ''
            that.addForm.bomsn = ''
            that.addForm.supplierid = ''
            that.addForm.contractunitprice = '0'
            that.addForm.contractamount = '0'
            that.addForm.contractnum = '0'
            that.addForm.SubPayment = []
            that.addForm.receivetime = ''
            that.addForm.beizhu = ''
            that.addForm.attachment = ''
            that.$refs.MultiImgOrPdf.cleardata()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDelErp6PurchaseOrder: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelErp6PurchaseOrder, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetErp6PurchaseOrderNum()
            that.apiGetErp6PurchaseOrderList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiShenPiErp6PurchaseOrder: function (okorno) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.modelShenPi.id,
        opinion: that.modelShenPi.opinion,
        okorno: okorno
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(that.apiShenPiErp6PurchaseOrderUrl, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetErp6PurchaseOrderNum()
            that.apiGetErp6PurchaseOrderList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiShenPiErp6PurchaseOrder0: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.modelSubmitAgain.id,
        reply: that.modelSubmitAgain.reply
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ShenPiErp6PurchaseOrder0, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetErp6PurchaseOrderNum()
            that.apiGetErp6PurchaseOrderList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}

.warntitle {
  margin-left: 65px;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: bold;
  color: rgb(127, 124, 126);
}

.productdata1 {
  padding-bottom: 20px;
}

.productdata2 {
  padding-bottom: 5px;
}

</style>
